import React, { PropsWithChildren } from "react";
import Card from "../card/Card";
import {
  centerHorizontal,
  centerVertical,
  flexColumn,
} from "../../reusableStyles/flex";
import { useTheme } from "@emotion/react";

export interface ModalDisplayProps {
  isOpen?: boolean;
  preventScroll?: boolean;
  withBackground?: boolean;
  preventClose?: boolean;
}

export interface ModalProps extends PropsWithChildren, ModalDisplayProps {
  onClose?: () => void;
}

const Modal: React.FC<ModalProps> = (props) => {
  const theme = useTheme();
  const withBackground =
    props.withBackground === undefined ? true : props.withBackground;
  const preventScroll =
    props.preventScroll === undefined ? true : props.preventScroll;

  React.useEffect(() => {
    if (props.isOpen && preventScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [props.isOpen]);

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <div
      css={[
        flexColumn,
        centerVertical,
        centerHorizontal,
        {
          width: "100vw",
          height: "100vh",
          backgroundColor: withBackground
            ? "rgba(52, 64, 84, 0.7)"
            : "transparent",
          backdropFilter: withBackground ? "blur(4px)" : undefined,
          position: "fixed",
          left: 0,
          top: 0,
          opacity: props.isOpen ? 1 : 0,
          visibility: props.isOpen ? "visible" : "hidden",
          transition: "all 0.45s ease-in-out",
          zIndex: theme.zIndex.overlay,
        },
      ]}
      onClick={() => {
        if (!props.preventClose) {
          handleClose();
        }
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        css={{
          transform: `scale(${props.isOpen ? 1 : 0})`,
          transition: "all 350ms cubic-bezier(.47, 1.64, .41, .8)",
          maxWidth: "50vw",
          boxShadow: theme.shadows.lg,
          zIndex: theme.zIndex.modal,
        }}
      >
        <Card>{props.children}</Card>
      </div>
    </div>
  );
};

export default Modal;
